<template>
  <div id="app">
    <!-- <svg height="0" xmlns="http://www.w3.org/2000/svg">
        <filter id="drop-shadow">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4"/>
            <feOffset dx="12" dy="12" result="offsetblur"/>
            <feFlood flood-color="rgba(0,0,0,0.5)"/>
            <feComposite in2="offsetblur" operator="in"/>
            <feMerge>
                <feMergeNode/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
    </svg> -->

    <img class="background-col-left lg" src="./assets/column3.png">

    <div class="background-buffer lg"></div>

    <div class="background-col-center">
      <span class="title md lg">AimeeOnTheHarp</span>
      <!-- <span id="free-lesson-ad-container" ng-click="onClickFreeLesson()">
        <img id="free-lesson-ad" class="starburst-shadow" src="img/starburst-design-clipart-2.png" />
        <span id="free-lesson-ad-text">Free Lesson!</span>
      </span> -->
    </div>

    <img class="background-col-right md lg" src="./assets/curve2.png">

    <div id="foreground">
      <div class="top-row md lg"></div>
      <div class="top-row sm gw-box no-padding">
        <div class="header sm">
          <div class="title sm">
            AimeeOnTheHarp
          </div>
          <!-- <div id="free-lesson-ad-small">
            <div id="free-lesson-ad-small-button" ng-click="onClickFreeLesson()">Free Lesson!</div>
          </div> -->
          <nav class="g-dropdown-container" role="navigation" ref="dropdownMenu">
            <button class="btn btn-black icon-menu g-dropdown-trigger" @click="toggleMenu"></button>
            <ul class="g-dropdown shadow right" role="menu" v-show="displayMenu">
							<router-link class="g-dropdown-item" v-for="(item, i) in menuItems" :key="i" :to="item.url">
								{{ item.name }}
							</router-link>
            </ul>
          </nav>
        </div>
        <button class="request-a-quote-button sm" @click="openQuoteDialog()">Request a Quote</button>
      </div>
      <div id="bottom-row">
        <div class="column-left lg"></div>
        <div class="column-center">
					<div class="gw-row">
						<div class="gw-column md lg">
							<button class="request-a-quote-button gw-box shadow" @click="openQuoteDialog()">Request a Quote</button>
							<ul class="gw-box shadow menu nav nav-pills nav-stacked no-padding">
								<!-- <li v-for="(item, i) in menuItems" :key="i" @click="onClickMenuItem(item)">
									<a href="#">{{item.name}}</a>
								</li> -->
								<router-link class="gui-menu-item" v-for="(item, i) in menuItems" :key="i" :to="item.url">
									{{ item.name }}
									<!-- <a href="#">{{item.name}}</a> -->
								</router-link>
							</ul>
						</div>
									
						<!-- <div id="main-content" class="content ah-vert-scroll"> -->
						<router-view></router-view>
						<!-- </div> -->
          </div>
        </div>
				<div class="column-right lg"></div>
      </div>

    </div>
		
		<quote-dialog :display-dialog="displayDialog" @close-dialog="closeQuoteDialog"></quote-dialog>
		
  </div>
</template>

<script>
import { bus } from '@/main'
import QuoteDialog from '@/components/QuoteDialog'

export default {
	
	name: 'App',
	
	components: {
		QuoteDialog
	},
	
  data() {
    return {
			displayDialog: false,
			displayMenu: false,
      menuItems: [{
        name: 'Home',
        url: '/'
      },{
        name: 'Repertoire',
        url: '/repertoire'
      },{
        name: 'Testimonials',
        url: '/testimonials'
      },{
        name: 'About',
        url: '/about'
      },{
        name: 'Contact',
        url: '/contact'
      }]
    };
	},
	
	created() {
		bus.$on('open-quote-dialog', this.openQuoteDialog);
		
		document.addEventListener('click', this.documentClick);
	},
	
	destroyed() {
		document.removeEventListener('click', this.documentClick);
	},
	
  methods: {
    openQuoteDialog: function() {
			this.$data.displayDialog = true;
		},
		
		closeQuoteDialog: function() {
			this.$data.displayDialog = false;
		},
		
		toggleMenu: function() {
			this.$data.displayMenu = !this.$data.displayMenu;
		},
		
		documentClick: function(event) {
			let el = this.$refs.dropdownMenu;
			let target = event.target;
			
			if((el !== target) && !el.contains(target)) {
				this.$data.displayMenu = false;
			}
		}
  }
}
</script>

<style>
button.g-dropdown-trigger {
	height: 26px;
}

.gui-menu-item {
  display: block;
  padding: 12px;
  border-radius: 4px;
  text-decoration: none;
}

.gui-menu-item:hover {
  background-color: #CCC;
}

.gui-menu-item.router-link-exact-active {
  background-color: #000;
  color: white;
}

.gw-btn.blue {
	background-color: #0996FF;
	color: #FFF;
}

.g-fill {
	width: 100%;
}
</style>
